import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import { Box, Divider } from "@mui/material";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import TableList from "./LimitTable";
import DefinationPopup from "./LimitDefinationPopup";
import AddLimit from "./AddLimit";
import Pagination from "../../../components/Pagination/index";
import React, { useState, useEffect, useMemo } from "react";
import BreadcrumbNav from "../header/BreadcrumbNav";
import DropdownsBar from "../header/ProductSiteUnitSelector";
import TabsNav from "../header/TabsNav";
import { useDispatch, useSelector } from "react-redux";
import * as limit from "../../../redux/limit/actions";
import "./limit.scss";
import Loader from "../../../components/Loader/loader";
import SnackBar from "../../../components/Snackbars/CustomizedSnackbars";
import ImportDialog from "../../../components/DialogBox/ImportDialog";
import ConfirmationDialog from "../../../components/DialogBox/Confirmation";
import MultipleInput from "../../../components/Card/MultipleInput";
import * as types from "../../../redux/limit/types";
import debounce from "lodash.debounce";
import AuditTable from "./LimitAuditTable";
import { getUsername } from "../../../constants/utility";
import BatchFilterPopup from "../../investigationAnalysis/review/BatchFilterPopup";
import { convertToDatePickerFormat, formatLocal, invalidIds } from '../../../utility';

const Index = () => {
  const [auditPage, setAuditPage] = useState(1);
  const [page, setPage] = useState(1);
  const [openDef, setOpenDef] = useState(false);
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [pendingFieldType, setPendingFieldType] = React.useState(null);
  const [openConfirmatonBox, setOpenConfirmatonBox] = useState(false);
  const [openLimit, setOpenLimit] = useState(false);
  const [isImportOpen, setIsImportOpen] = useState(false);
  const [auditFillter, setAuditFillter] = useState(false);
  const rowsPerPage = 50;
  const tableHeaders = [
    "",
    "Parameter Name",
    "Unit of Measure",
    "Values",
    "Status",
    "Set",
    "Valid From",
    "Action",
  ];
  const { unitOfOperation } = useSelector(
    (state) => state.shared?.productSitesUopValues || {}
  );
  const [openData, setOpenData] = useState(unitOfOperation?.id || null);
  const [childData, setChildData] = useState();
  const dispatch = useDispatch();
  const rowData = useSelector((state) => state?.limitReducer?.rows);
  const parameter = useSelector((state) => state?.limitReducer?.parameter);
  const auditLogs = useSelector((state) => state?.limitReducer?.audit_logs);
  const limitOperation = useSelector(
    (state) => state?.limitReducer?.limitOperation
  );
  const [addErrors, setAddErrors] = useState();
  const [viewPrimaryData, setViewPrimaryData] = useState();
  const [viewData, setViewData] = useState();
  const [fieldType, setFieldType] = React.useState("control");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [search, setSearch] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState();
  const [viewLogs, setViewLogs] = useState(false);
  const [filters, setFilters] = useState({
    updated_created_date: "",
    updated_end_date: "",
    batch_status: "",
  });
  const group1 = ["active", "inactive"];
  const group2 = [
    "Current",
    "Draft",
    // "Obsolete"
  ];

  const handleAuditPageChange = (event, value) => {
    setAuditPage(value);
    getAuditData(value);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getListData(value)
  };

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (unitOfOperation?.id) {
      dispatch(limit.getParaSpecList({ unit_op_id: unitOfOperation?.id }));
    }
    dispatch(limit.clearDropdownResponse());
    // dispatch(limit.clearResponse());
    setOpenData(null);
  }, [unitOfOperation?.id, dispatch]);

  useEffect(() => {
    if (limitOperation?.status === 200) {
      setSnack({
        open: true,
        message: limitOperation?.message,
        severity: "success",
      });
      setOpenLimit(false);
      setOpenDef(false);
      setSpecificationForm(intialStageOfAddSpecification);
      setAddLimitData(intialStageOfAddTarget);
      setAddTargetData(intialStageOfAddTargetData);
      getUpdatedList();
    } else if (limitOperation?.message) {
      setSnack({
        open: true,
        message: limitOperation?.message,
        severity: "error",
      });
      setOpenDef(false);
    }
    dispatch({ type: types.CLEAR_LIMIT_MESSAGE });
  }, [limitOperation?.data]);

  const getUpdatedList = () => {
    getListData(page);
  };

  // add forms

  const intialStageOfAddTarget = {
    parameter_id: null,
    validFrom: null,
    validThrough: null,
    boxCoxLambdaValue: null,
    lcl: null,
    ucl: null,
    lwl: null,
    uwl: null,
    lil: null,
    uil: null,
    mean: null,
    ststddev: null,
    ltstddev: null,
    cp: null,
    cpl: null,
    cpu: null,
    cpk: null,
    pp: null,
    ppl: null,
    ppu: null,
    ppk: null,
    changeReason: null,
  };

  const intialStageOfAddTargetData = {
    parameter_id: null,
    validFrom: null,
    validThrough: null,
    changeReason: null,
    processTarget: null,
  };

  const intialStageOfAddSpecification = {
    parameter_id: null,
    validFrom: null,
    validThrough: null,
    acceptanceValue: [""],
    acceptanceCriteria: null,
    method: null,
    changeReason: null,
    spec_name: null,
    processTarget: null,
    // boxCoxLambdaValue: null,
    specificationLimitBlock: [
      {
        specificationLimit: null,
        lowerLimitType: null,
        lowerLimitValue: null,
        upperLimitType: null,
        upperLimitValue: null,
      },
    ],
  };

  const [addLimitData, setAddLimitData] = useState(intialStageOfAddTarget);
  const [addTargetData, setAddTargetData] = useState(
    intialStageOfAddTargetData
  );
  const [sepcificaitonForm, setSpecificationForm] = useState(
    intialStageOfAddSpecification
  );

  const comparisonRules = [
    { min: "lcl", max: "ucl", message: "UCL must be greater than LCL" },
    { min: "lwl", max: "uwl", message: "UWL must be greater than LWL" },
    { min: "lil", max: "uil", message: "UIL must be greater than LIL" },
  ];

  const validateAddErrors = (isRequired) => {
    setAddErrors({});
    const newErrors = {};
    if (!addLimitData.parameter_id) newErrors.parameter_id = "Required";
    if (!addLimitData.validFrom) newErrors.validFrom = "Required";
    if (isRequired && !addLimitData.changeReason) newErrors.changeReason = "Required";
    if (!addLimitData.lcl && !addLimitData.ucl) {
      newErrors.lcl = "Either LCL or UCL is required";
      newErrors.ucl = "Either LCL or UCL is required";
    }

    // Validate comparison rules
    comparisonRules.forEach(({ min, max, message }) => {
      if (
        addLimitData[min] !== undefined &&
        addLimitData[max] !== undefined &&
        addLimitData[min] !== null &&
        addLimitData[max] !== null &&
        Number(addLimitData[max]) <= Number(addLimitData[min])
      ) {
        newErrors[max] = message;
      }
    });

    setAddErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const validateAddTargetErrors = (isRequired) => {
    setAddErrors({});
    const newErrors = {};
    if (!addTargetData.parameter_id) newErrors.parameter_id = "Required";
    if (!addTargetData.validFrom) newErrors.validFrom = "Required";
    if (isRequired && !addTargetData.changeReason) newErrors.changeReason = "Required";
    if (!addTargetData.processTarget) newErrors.processTarget = "Required";

    setAddErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const validateAddSpecErrors = (isRequired) => {
    setAddErrors({});
    const newErrors = {};

    if (!sepcificaitonForm.parameter_id) newErrors.parameter_id = "Required";
    if (!sepcificaitonForm.validFrom) newErrors.validFrom = "Required";
    if (isRequired && !sepcificaitonForm.changeReason) newErrors.changeReason = "Required";

    // const processTarget = !sepcificaitonForm.processTarget;
    if (!invalidIds.includes(sepcificaitonForm?.parameter_id)) {
      if (!sepcificaitonForm.spec_name) newErrors.spec_name = "Required";
      let blockErrors = [];

      sepcificaitonForm.specificationLimitBlock.forEach((block, index) => {
        const lower = parseFloat(block.lowerLimitValue ?? "");
        const upper = parseFloat(block.upperLimitValue ?? "");
        let blockError = {};

        const lowerEmpty =
          block.lowerLimitValue === "" || block.lowerLimitValue == null;
        const upperEmpty =
          block.upperLimitValue === "" || block.upperLimitValue == null;

        // ✅ At least one required
        if (lowerEmpty && upperEmpty) {
          blockError.lowerLimitValue =
            "Either lower or upper limit is required";
          blockError.upperLimitValue =
            "Either lower or upper limit is required";
          // newErrors.processTarget = "Either target or limit is required";
        }

        // ✅ If lower filled, lower type required
        if (
          !lowerEmpty &&
          (block.lowerLimitType === "" || block.lowerLimitType == null)
        ) {
          blockError.lowerLimitType = "required";
        }

        // ✅ If upper filled, upper type required
        if (
          !upperEmpty &&
          (block.upperLimitType === "" || block.upperLimitType == null)
        ) {
          blockError.upperLimitType = "required";
        }

        // ✅ If both filled, check comparison
        if (
          !lowerEmpty &&
          !upperEmpty &&
          !isNaN(lower) &&
          !isNaN(upper) &&
          upper <= lower
        ) {
          blockError.upperLimitValue = "Must be greater than lower limit";
        }

        blockErrors[index] =
          Object.keys(blockError).length > 0 ? blockError : null;
      });

      if (blockErrors.some((e) => e !== null)) {
        newErrors.specificationLimitBlock = blockErrors;
      }
    }

    setAddErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddLimitChange = (e) => {
    const { name, value } = e.target;

    let newValue;
    if (typeof value === "string") {
      newValue = value?.trim() === "" ? null : value;
    } else {
      newValue = value === "" ? null : value;
    }
    setAddErrors((prevErrors) => {
      if (!prevErrors[name]) return prevErrors;
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
    if (fieldType === "control") {
      setAddLimitData((prev) => ({ ...prev, [name]: newValue }));
    } else if (fieldType === "target") {
      setAddTargetData((prev) => ({ ...prev, [name]: newValue }));
    } else {
      setSpecificationForm((prev) => ({ ...prev, [name]: newValue }));
    }
  };

  const handleAddSubmit = (e) => {
    e.preventDefault();

    if (fieldType === "control") {
      if (!validateAddErrors(false)) return;
      const data = {
        data_for: "control_limit",
        unit_op_id: unitOfOperation?.id,
        created_by: getUsername(),
      };
      dispatch(limit.AddLimitData(data, addLimitData));
    } else if (fieldType === "target") {
      if (!validateAddTargetErrors(false)) return;
      const data = {
        data_for: "target_limit",
        unit_op_id: unitOfOperation?.id,
        created_by: getUsername(),
      };
      dispatch(limit.AddLimitData(data, addTargetData));
    } else {
      if (!validateAddSpecErrors(false)) return;
      const data = {
        data_for: "specification_limit",
        unit_op_id: unitOfOperation?.id,
        created_by: getUsername(),
      };
      if (invalidIds.includes(sepcificaitonForm?.parameter_id)) {
        sepcificaitonForm.specificationLimitBlock = [];
      }
      dispatch(limit.AddLimitData(data, sepcificaitonForm));
    }
  };

  const handleSaveAsDraft = (e) => {
    e.preventDefault();

    if (fieldType === "control") {
      const data = {
        data_for: "control_limit",
      };
      addLimitData.is_draft = true;
      dispatch(limit.DraftLimitData(data, addLimitData));
    } else {
      const data = {
        data_for: "specification_limit",
      };
      sepcificaitonForm.is_draft = true;
      if (invalidIds.includes(sepcificaitonForm?.parameter_id)) {
        delete sepcificaitonForm.specificationLimitBlock;
      }
      dispatch(limit.DraftLimitData(data, sepcificaitonForm));
    }
  };

  const handleSubmitDefinition = (e, isAddOperationType) => {
    e.preventDefault();

    if (fieldType === "control") {
      if (!validateAddErrors(true)) return;
      const data = {
        data_for: "control_limit",
      };
      if (isAddOperationType) {
        dispatch(limit.AddLimitData(data, addLimitData));
      } else {
        addLimitData.data_for = "control_limit";
        addLimitData.stat_limit_id = viewData?.stat_limit_id;
        addLimitData.unit_op_id = unitOfOperation?.id;
        addLimitData.updated_by = getUsername();
        dispatch(limit.UpdateLimit(data, addLimitData));
      }
    } else if (fieldType === "target") {
      const data = {
        data_for: "target_limit",
      };
      if (isAddOperationType) {
        dispatch(limit.AddLimitData(data, addTargetData));
      } else {
        addTargetData.data_for = "target_limit";
        addTargetData.id = viewData?.id;
        dispatch(limit.UpdateLimit(data, addTargetData));
      }
    } else {
      if (!validateAddSpecErrors(true)) return;
      const data = {
        data_for: "specification_limit",
      };
      if (invalidIds.includes(sepcificaitonForm?.parameter_id)) {
        delete sepcificaitonForm.specificationLimitBlock;
      }
      if (isAddOperationType) {
        dispatch(limit.AddLimitData(data, sepcificaitonForm));
      } else {
        sepcificaitonForm.data_for = "specification_limit";
        sepcificaitonForm.spec_limit_id = viewData?.spec_limit_id;
        sepcificaitonForm.unit_op_id = unitOfOperation?.id;
        sepcificaitonForm.updated_by = getUsername();
        dispatch(limit.UpdateLimit(data, sepcificaitonForm));
      }
    }
  };

  const handleSaveAsDraftUpdate = (e, isAddOperationType) => {
    e.preventDefault();

    if (fieldType === "control") {
      const data = {
        data_for: "control_limit",
        unit_op_id: unitOfOperation?.id,
        created_by: getUsername(),
      };
      if (isAddOperationType) {
        addLimitData.is_draft = true;
        addLimitData.unit_op_id = unitOfOperation?.id;
        addLimitData.created_by = getUsername();
        dispatch(limit.DraftLimitData(data, addLimitData));
      } else {
        addLimitData.data_for = "control_limit";
        addLimitData.stat_limit_id = viewData?.stat_limit_id;
        addLimitData.is_draft = true;
        addLimitData.unit_op_id = unitOfOperation?.id;
        addLimitData.created_by = getUsername();
        dispatch(limit.DraftUpdateLimit(data, addLimitData));
      }
    } else if (fieldType === "target") {
      const data = {
        data_for: "target_limit",
        unit_op_id: unitOfOperation?.id,
        created_by: getUsername(),
      };
      if (isAddOperationType) {
        addTargetData.is_draft = true;
        dispatch(limit.DraftLimitData(data, addTargetData));
      } else {
        addTargetData.data_for = "target_limit";
        addTargetData.id = viewData?.id;
        addTargetData.is_draft = true;
        addTargetData.unit_op_id = unitOfOperation?.id;
        addTargetData.created_by = getUsername();
        dispatch(limit.DraftUpdateLimit(data, addTargetData));
      }
    } else {
      const data = {
        data_for: "specification_limit",
        unit_op_id: unitOfOperation?.id,
        created_by: getUsername(),
      };
      if (invalidIds.includes(sepcificaitonForm?.parameter_id)) {
        sepcificaitonForm.specificationLimitBlock = [];
      }
      if (isAddOperationType) {
        sepcificaitonForm.is_draft = true;
        dispatch(limit.AddLimitData(data, sepcificaitonForm));
      } else {
        sepcificaitonForm.data_for = "specification_limit";
        sepcificaitonForm.spec_limit_id = viewData?.spec_limit_id;
        sepcificaitonForm.is_draft = true;
        sepcificaitonForm.unit_op_id = unitOfOperation?.id;
        sepcificaitonForm.created_by = getUsername();
        dispatch(limit.DraftUpdateLimit(data, sepcificaitonForm));
      }
    }
  };

  const hanldeViewData = (data, primaryRow, section) => {
    if (section === "control") {
      setAddLimitData({
        parameter_id: data.parameter_id ?? null,
        validFrom: convertToDatePickerFormat(data.valid_from) ?? null,
        validThrough: convertToDatePickerFormat(data.valid_through) ?? null,
        boxCoxLambdaValue: data.box_cox_lambda_value ?? null,
        lcl: data.lower_control ?? null,
        ucl: data.upper_control ?? null,
        lwl: data.lower_warning ?? null,
        uwl: data.upper_warning ?? null,
        lil: data.lil ?? null,
        uil: data.uil ?? null,
        mean: data.target_mean ?? null,
        ststddev: data.st_std_dev ?? null,
        ltstddev: data.lt_std_dev ?? null,
        cp: data.cp ?? null,
        cpl: data.cpl ?? null,
        cpu: data.cpu ?? null,
        cpk: data.cpk ?? null,
        pp: data.pp ?? null,
        ppl: data.ppl ?? null,
        ppu: data.ppu ?? null,
        ppk: data.ppk ?? null,
        changeReason: null,
      });
    } else if (section === "target") {
      setAddTargetData({
        parameter_id: data.parameter_id ?? null,
        validFrom: convertToDatePickerFormat(data.valid_from) ?? null,
        validThrough: convertToDatePickerFormat(data.valid_through) ?? null,
        processTarget: data.process_target ?? null,
        changeReason: null,
      });
    } else {

      setSpecificationForm({
        parameter_id: data.parameter_id ?? null,
        validFrom: convertToDatePickerFormat(data.valid_from) ?? null,
        validThrough: convertToDatePickerFormat(data.valid_through) ?? null,
        acceptanceValue: data.acceptable_value
          ?.replace(/[{}"\\]/g, "")
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v !== "") || [null],
        acceptanceCriteria: data.acceptance_criteria ?? null,
        method: data.method ?? null,
        changeReason: null,
        spec_name: data.spec_name ?? null,
        processTarget: data.process_target ?? null,
        // boxCoxLambdaValue: data.boxcoxlambdavalue ?? null,
        specificationLimitBlock: data.specification_limit_block || [
          {
            specificationLimit: null,
            lowerLimitType: data.lower_limit_type ?? null,
            lowerLimitValue: data.lower_spec ?? null,
            upperLimitType: data.upper_limit_type ?? null,
            upperLimitValue: data.upper_spec ?? null,
          },
        ],
      });
    }
    setOpenDef(true);
    setViewData(data);
    setFieldType(section);
    setAddErrors({});
    setViewPrimaryData(primaryRow);
  };

  const handleClick = (data) => {
    if (openData === data.unit_op_id) {
      setOpenData(null);
      setChildData(null);
      return;
    }
    setOpenData(data.unit_op_id);
    setChildData(null);
    let params = {};
    if (data.unit_op_id) {
      params.unit_op_id = data.unit_op_id;
    }
    params.page = page;
    params.page_size = rowsPerPage;
    getListData(params);
  };

  const handleChildClick = (data) => {
    // let params = {};
    // if (childData === data) {
    //   setChildData(null);
    //   if (openData) params.unit_op_id = openData;
    // } else {
    //   setChildData(data);
    //   if (openData) params.unit_op_id = openData;
    //   if (data) params.table_name = data;
    // }
    // getListData(params);
  };

  const handleMenuOptionCallBack = (option, item) => {
    setOpenLimit(true);
    setFieldType("control");
    setAddLimitData(intialStageOfAddTarget);
    setAddTargetData(intialStageOfAddTargetData);
    setSpecificationForm(intialStageOfAddSpecification);
  };

  const importXlFile = (file) => {
    dispatch(limit.ImportLimitData(file));
  };

  const handleAcceptanceValueChange = (type, index, value) => {
    const updatedValues = [...sepcificaitonForm?.acceptanceValue];
    updatedValues[index] = value;
    setSpecificationForm((prev) => ({
      ...prev,
      acceptanceValue: updatedValues,
    }));
  };

  const handleDeleteAcceptanceValue = (type, index) => {
    const updatedValues = [...sepcificaitonForm.acceptanceValue];
    updatedValues.splice(index, 1);
    setSpecificationForm((prev) => ({
      ...prev,
      acceptanceValue: updatedValues,
    }));
  };

  const handleAddAcceptanceValue = (type) => {
    setSpecificationForm((prev) => ({
      ...prev,
      acceptanceValue: [...prev.acceptanceValue, ""],
    }));
  };

  const handleBlockChange = (type, index, field, value) => {
    const updatedBlocks = [...sepcificaitonForm.specificationLimitBlock];
    updatedBlocks[index][field] = value === "" ? null : value;
    setSpecificationForm((prev) => ({
      ...prev,
      specificationLimitBlock: updatedBlocks,
    }));
  };

  const handleAddBlock = (type) => {
    setSpecificationForm((prev) => ({
      ...prev,
      specificationLimitBlock: [
        ...prev.specificationLimitBlock,
        {
          specificationLimit: "",
          lowerLimitType: "",
          lowerLimitValue: "",
          upperLimitType: "",
          upperLimitValue: "",
        },
      ],
    }));
  };

  const handleDeleteBlock = (type, index) => {
    const updated = [...sepcificaitonForm.specificationLimitBlock];
    updated.splice(index, 1);
    setSpecificationForm((prev) => ({
      ...prev,
      specificationLimitBlock: updated,
    }));
  };

  const handleCheckboxChange = (option) => {
    setSelectedFilters((prevSelected) => {
      let updatedSelected = [];

      if (prevSelected.includes(option)) {
        updatedSelected = prevSelected.filter((item) => item !== option);
      } else {
        if (group1.includes(option)) {
          updatedSelected = [
            ...prevSelected.filter((item) => !group1.includes(item)),
            option,
          ];
        } else if (group2.includes(option)) {
          updatedSelected = [
            ...prevSelected.filter((item) => !group2.includes(item)),
            option,
          ];
        } else {
          updatedSelected = prevSelected;
        }
      }
      const status = updatedSelected?.find((item) => group1?.includes(item));
      const parameter_status = updatedSelected?.find((item) =>
        group2?.includes(item)
      );

      getListData(1, false, status, parameter_status);
      // if (openData) {
      // }

      return updatedSelected;
    });
  };

  const handleConfirmDelete = () => {
    setOpenConfirmatonBox(true);
  };

  const handleDelete = () => {
    setOpenConfirmatonBox(false);
    let params = {};
    if (fieldType === "control") {
      params = {
        data_for: "control_limit",
        stat_limit_id: viewData?.stat_limit_id,
        unit_op_id: unitOfOperation?.id,
        deleted_by: getUsername(),
      };
    } else if (fieldType === "target") {
      params = {
        data_for: "target_limit",
        id: viewData?.id,
        unit_op_id: unitOfOperation?.id,
        deleted_by: getUsername(),
      };
    } else {
      params = {
        data_for: "specification_limit",
        spec_limit_id: viewData?.spec_limit_id,
        unit_op_id: unitOfOperation?.id,
        deleted_by: getUsername(),
      };
    }
    dispatch(limit.DeleteLimit(params));
  };

  const handleAddLimitOpen = () => {
    if (!unitOfOperation?.id) {
      return setSnack({
        open: true,
        message: "Please select a unit operation first.",
        severity: "warning",
      });
    }
    setOpenLimit(true);
    setAddErrors({});
    setAddLimitData(intialStageOfAddTarget);
    setSpecificationForm(intialStageOfAddSpecification);
    setFieldType("control");
  };

  const handleCloseAddLimit = () => {
    setOpenLimit(false);
    setOpenDef(false);
    setAddErrors({});
    setAddLimitData(intialStageOfAddTarget);
    setSpecificationForm(intialStageOfAddSpecification);
    setFieldType("control");
  };

  const debouncedSetValue = useMemo(
    () =>
      debounce((val) => {
        setDebouncedSearch(val);
      }, 700),
    []
  );

  const handleSearch = (e) => {
    setSearch(e.target.value);
    debouncedSetValue(e.target.value);
  };

  useEffect(() => {
    if (viewLogs) {
      getAuditData(1);
    } else {
      if (unitOfOperation?.id) {
        getListData(1);
      }
    }
  }, [debouncedSearch, unitOfOperation?.id, dispatch]);

  const handleSetFieldType = (data) => {
    let hasValues = false;

    if (fieldType === "control") {
      hasValues = Object.values(addLimitData || {}).some(
        (val) => val !== "" && val !== null
      );
    } else if (fieldType === "target") {
      hasValues = Object.values(addTargetData || {}).some(
        (val) => val !== "" && val !== null
      );
    } else {
      hasValues = Object.entries(sepcificaitonForm || {}).some(([key, val]) => {
        if (key === "acceptanceValue" && Array.isArray(val)) {
          return val.some((v) => v !== "" && v !== null);
        }
        if (key === "specificationLimitBlock" && Array.isArray(val)) {
          return val.some((block) =>
            Object.values(block).some((v) => v !== "" && v !== null)
          );
        }
        return val !== "" && val !== null;
      });
    }

    if (hasValues) {
      setPendingFieldType(data);
      setConfirmOpen(true);
      return;
    }

    applyFieldTypeChange(data);
  };

  const applyFieldTypeChange = (data) => {
    setFieldType(data);
    setSpecificationForm(intialStageOfAddSpecification);
    setAddLimitData(intialStageOfAddTarget);
    setAddTargetData(intialStageOfAddTargetData);
  };

  const viewAuditLogs = () => {
    setViewLogs(!viewLogs);

    if (!viewLogs) getAuditData(1);
  };

  const getAuditData = (page, reset = false) => {
    if (!unitOfOperation?.id) {
      return setSnack({
        open: true,
        message: "Please select a unit operation first.",
        severity: "warning",
      });
    }
    const params = {
      page: page,
      unit_op_id: unitOfOperation?.id,
      page_size: rowsPerPage,
    };
    if (reset) return dispatch(limit.getAuditList(params));
    if (filters.updated_created_date) params.start_date = formatLocal(filters.updated_created_date);
    if (filters.updated_end_date) params.end_date = formatLocal(filters.updated_end_date);
    if (filters.batch_status) params.status = filters.batch_status;
    if (debouncedSearch) params.search = debouncedSearch;
    dispatch(limit.getAuditList(params));
  };

  const handlePopupFilter = () => {
    setAuditFillter(!auditFillter);
  };

  const handleReset = () => {
    setFilters({
      updated_created_date: "",
      updated_end_date: "",
      batch_status: "",
    });
    if (viewLogs) {
      getAuditData(1, true);
    } else {
      getListData(1, true);
    }
  };

  const getListData = (page, reset = false, status, parameter_status) => {
    if (!unitOfOperation?.id) {
      return setSnack({
        open: true,
        message: "Please select a unit operation first.",
        severity: "warning",
      });
    }
    const params = {
      page: page,
      unit_op_id: unitOfOperation?.id,
      page_size: rowsPerPage,
    };
    // params.page_size = rowsPerPage;
    if (reset) return dispatch(limit.getLimitList(params));
    // if (filters.from_date) params.start_date = filters.from_date;
    if (parameter_status) params.parameter_status = parameter_status;
    if (status) params.status = status;
    if (debouncedSearch) params.search = debouncedSearch;
    dispatch(limit.getLimitList(params));
  };

  const handleChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleGenerate = () => {
    if (viewLogs) {
      getAuditData(1);
    } else {
      setPage(1);
      getListData(1);
    }
  };

  const filterOptions = [
    { label: "Current", value: "Current" },
    { label: "Obsolete", value: "Obsolete" },
  ];

  return (
    <Box>
      {" "}
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        <TabsNav />
        <DropdownsBar />
        <Divider sx={{ mx: 2 }} />
        <Box sx={{ py: 0.5 }}>
          <BreadcrumbNav />
        </Box>
        <Divider sx={{ mx: 2 }} />

        {snack?.open && (
          <SnackBar
            className="popup"
            handleClose={() => {
              setSnack({
                open: false,
                message: "",
                severity: "",
              });
            }}
            severity={snack.severity}
            state={snack?.open}
            text={snack?.message}
          />
        )}
        <Box className="collapse-card-container">
          <Box>
            <MultipleInput
              text={!viewLogs ? "Limits" : "Audit Trail"}
              buttonText={"Add Limit"}
              onButtonClick={handleAddLimitOpen}
              handleChildClick={handleChildClick}
              handleClick={handleClick}
              handleMenuOptionCallBack={handleMenuOptionCallBack}
              filterOptionsGroup1={group1}
              filterOptionsGroup2={group2}
              selectedFilters={selectedFilters}
              handleCheckboxChange={handleCheckboxChange}
              isButton={true}
              isAuditLogs={true}
              handleSearch={handleSearch}
              search={search}
              viewAuditLogs={viewAuditLogs}
              auditText={"Audit Trail"}
              viewLogs={viewLogs}
              popupFilter={viewLogs}
              handlePopupFilter={handlePopupFilter}
              onBackClick={() => setViewLogs(false)}
            />
          </Box>
          {viewLogs ? (
            <>
              <Box width="100%" className="custom-table-container">
                <AuditTable data={auditLogs} />
                {auditLogs?.loader && <Loader />}
                <Pagination
                  count={auditLogs?.data?.total / rowsPerPage}
                  page={auditPage}
                  onChange={handleAuditPageChange}
                />
              </Box>
            </>
          ) : (
            <>
              <Box width="100%" className="custom-table-container">
                <TableList
                  data={rowData || []}
                  onView={hanldeViewData}
                  handleAddLimit={() => setOpenLimit(true)}
                  tableHeaders={tableHeaders}
                  openData={openData}
                />
                {rowData?.loader && <Loader />}
                <Pagination
                  count={rowData?.data?.total / rowsPerPage}
                  page={page}
                  onChange={handlePageChange}
                />
              </Box>
            </>
          )}
        </Box>
        <Box>
          <DefinationPopup
            open={openDef}
            onClose={handleCloseAddLimit}
            formData={addLimitData}
            onChange={handleAddLimitChange}
            errors={addErrors}
            handleSubmit={handleSubmitDefinition}
            sepcificaitonFormUpdate={sepcificaitonForm}
            setFieldType={handleSetFieldType}
            fieldType={fieldType}
            viewData={viewData}
            viewPrimaryData={viewPrimaryData}
            handleAcceptanceValueChange={handleAcceptanceValueChange}
            handleDeleteAcceptanceValue={handleDeleteAcceptanceValue}
            handleAddAcceptanceValue={handleAddAcceptanceValue}
            handleAddBlock={handleAddBlock}
            handleDeleteBlock={handleDeleteBlock}
            handleBlockChange={handleBlockChange}
            openData={openData}
            handleDelete={handleConfirmDelete}
            parameter={parameter?.data || []}
            handleSaveAsDraft={handleSaveAsDraftUpdate}
            limitOperation={limitOperation}
            addTargetData={addTargetData}
          />
        </Box>
        <Box>
          <AddLimit
            open={openLimit}
            onClose={handleCloseAddLimit}
            formData={addLimitData}
            addTargetData={addTargetData}
            onChange={handleAddLimitChange}
            errors={addErrors}
            handleSubmit={handleAddSubmit}
            setFieldType={handleSetFieldType}
            fieldType={fieldType}
            sepcificaitonForm={sepcificaitonForm}
            handleAcceptanceValueChange={handleAcceptanceValueChange}
            handleDeleteAcceptanceValue={handleDeleteAcceptanceValue}
            handleAddAcceptanceValue={handleAddAcceptanceValue}
            handleBlockChange={handleBlockChange}
            handleAddBlock={handleAddBlock}
            handleDeleteBlock={handleDeleteBlock}
            parameter={parameter?.data || []}
            limitOperation={limitOperation}
            handleSaveAsDraft={handleSaveAsDraft}
          />
        </Box>
        <BatchFilterPopup
          open={auditFillter}
          onClose={() => setAuditFillter(false)}
          filterValues={filters}
          onReset={handleReset}
          onGenerate={handleGenerate}
          data={auditLogs || []}
          onChange={handleChange}
          isStatusVisible={true}
          filterOptions={filterOptions}
        />
        <ImportDialog
          open={isImportOpen}
          onClose={() => setIsImportOpen(false)}
          onImport={importXlFile}
        />
        <ConfirmationDialog
          open={openConfirmatonBox}
          title="Confirm Deletion"
          message="Do you really want to delete this record?"
          onConfirm={handleDelete}
          onCancel={() => setOpenConfirmatonBox(false)}
        />
        <ConfirmationDialog
          open={confirmOpen}
          title="Alert"
          message="Changing field type will erase entered values. Do you want to continue?"
          onConfirm={() => {
            if (pendingFieldType) applyFieldTypeChange(pendingFieldType);
            setConfirmOpen(false);
            setPendingFieldType(null);
          }}
          onCancel={() => {
            setConfirmOpen(false);
            setPendingFieldType(null);
          }}
          text="Continue"
        />
      </InvestigatorContainer>
    </Box>
  );
};

export default Index;
